import React from "react";
import AddressLocationSelector from "./addressLocation/AddressLocationSelector";
import "./CountryZipLocationFields.css";

// Country / ZIP / State / City of a profile or an audience filter (Agent
// profile, role request "Your First Step", Email Marketing audience). Since
// 2026-10-02 it is the shared AddressLocationSelector: Country -> ZIP fills
// the state and the city (as before), and Country -> State -> City works
// without the ZIP; every field stays editable.
//
// value: { country, zipCode, city, state, latitude, longitude, ...other }
// (other keys of the caller's object are kept untouched).
const CountryZipLocationFields = ({
  value = {},
  onChange,
  infoSource,
  emptyCountryLabel,
  disabled = false,
  className = ""
}) => {
  const tr = (key, fallback) =>
    infoSource?.laguangeElakay?.("agentProfile", infoSource.languageAPI)?.[key] || fallback;

  const location = {
    country: value.country || "",
    state: value.state || "",
    stateCode: value.stateCode || "",
    city: value.city || "",
    postalCode: value.zipCode || "",
    latitude: value.latitude ?? null,
    longitude: value.longitude ?? null,
  };
  const change = (next) => onChange?.({
    ...value,
    country: next.country,
    state: next.state,
    city: next.city,
    zipCode: next.postalCode,
    latitude: next.latitude ?? null,
    longitude: next.longitude ?? null,
  });

  return (
    <AddressLocationSelector
      value={location}
      onChange={change}
      tr={tr}
      disabled={disabled}
      idPrefix={`czl-${className || "location"}`.replace(/\s+/g, "-")}
      emptyCountryLabel={emptyCountryLabel || tr("selectCountry", "Select a country")}
      wrapperClassName={`country-zip-location ${className}`.trim()}
      classNames={{ field: "country-zip-field", status: "country-zip-status" }}
    />
  );
};

export default CountryZipLocationFields;
